import React from 'react'
import Properties from '../components/allPropertyListing/Properties'

const PropertyListing = () => {
  return (
    <Properties/>
  )
}

export default PropertyListing